import { Component } from '@angular/core';
import { LoadingData } from '../cevi-http-interceptor';
import { map, merge, scan } from 'rxjs';
import { AsyncPipe, NgIf } from '@angular/common';

@Component({
    selector: 'cevi-loading',
    // [@loadingState] = animation trigger syntax (see animations trigger)
    templateUrl: 'loading.component.html',
    styleUrls: ['loading.component.scss'],
    standalone: true,
    imports: [NgIf, AsyncPipe]
})
  export class LoadingComponent {
  
    public isHidden = true;
  
    constructor(public data: LoadingData) {}
    
    public outstandingCalls$ = merge(
      this.data.incrSubj.pipe(map(() => 1)),
      this.data.decrSubj.pipe(map(() => -1)),
      this.data.stopSubj.pipe(map(() => -99))
    ).pipe(
      scan((prev, delta) => {
        if (delta === -99) { return 0; }
        const newValue = prev + delta;
        return newValue < 0 ? 0 : newValue;
      }, 0),
    );
  
  }
  